module.exports = __webpack_public_path__ + "static/img/BeCool-Logo.0ee43fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BeCool-Logo.png
// module id = Qphs
// module chunks = 1